import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {Title} from "../../../../components/components";
import FormButton from "../../../../components/forms/FormButton";
import {useCreateUserMutation} from "../../../../api/userApiSlice";
import {DataVendorUserForm} from "../../../../components/data_vendors/DataVendorUserForm";

function NewUser(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [createUser] = useCreateUserMutation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})

  const goToUser = (data) => history.push(`/users/${data.slug}`)

  const handleSubmit = (data) => {
    createUser({user: data}).unwrap()
      .then(goToUser)
      .catch(error => {})
  }

  return (
    <>
      <Title main={t("menu.users")} sub={t('users.new')} group={false} backPath="/users">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <DataVendorUserForm handleSubmit={handleSubmit} setSubmitButtonProps={setSubmitButtonProps} canSelectRole={false}/>
    </>
  )
}

export default NewUser
